import styled from 'styled-components';

export const StyledTbmStatusDashboardWork = styled.div<{ color: string }>`
  background: ${(props) => props.color};
  padding: 16px;
  border-radius: 10px;
  width: 140px;
`;

export const StyledWorkTitle = styled.div<{ color: string }>`
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  color: ${(props) => props.color};
  text-align: center;
`;
